module.exports = __webpack_public_path__ + "img/at-the-office.703eeede.png";